import { render, staticRenderFns } from "./NavbarFrench.vue?vue&type=template&id=240842fe&scoped=true&"
import script from "./NavbarFrench.vue?vue&type=script&lang=js&"
export * from "./NavbarFrench.vue?vue&type=script&lang=js&"
import style0 from "./NavbarFrench.vue?vue&type=style&index=0&id=240842fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240842fe",
  null
  
)

export default component.exports